<template>
    <div class="list">
        <h3>{{ $t('pages.calendar.oldDatesList.header') }}</h3>
        <ul class="old-dates">
            <li
                v-for="(dateObj, index) in oldDates"
                :key="index"
                class="old-dates__item"
            >
                {{ index + 1 }}.
                <div class="old-dates__container">
                    <div class="old-dates__date">
                        <DateCell :value="dateObj.value" :utc="false" />

                        <v-icon small color="#967ADC" class="old-dates__icon">
                            mdi-arrow-right-bold
                        </v-icon>

                        <DateCell :value="dateObj.new_value" :utc="false" />
                    </div>

                    <hr />

                    <div class="old-dates__additional">
                        <div class="old-dates__updated-at">
                            <DateCell
                                :value="dateObj.updated_at"
                                :utc="false"
                            />
                        </div>
                        <p class="old-dates__updated-by">
                            {{ dateObj.user }}
                        </p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import DateCell from '@/components/common/cells/date-cell.vue'

export default {
    name: 'CalendarOldDatesList',
    components: { DateCell },
    props: {
        oldDates: {
            type: Array,
            default: () => [{}],
        },
    },
    data() {
        return {
            key: 'value',
        }
    },
    methods: {},
}
</script>

<style lang="scss">
.old-dates {
    font-size: 13px;
    padding: 0 0 0 !important;
    display: flex;
    flex-direction: column;
    gap: 4px;

    &__item {
        display: flex;
        align-items: center;
        gap: 4px;

        p {
            direction: ltr !important;
        }
    }

    &__container {
        border: 1px solid #967adc;
        border-radius: 8px;
        padding: 5px;
        width: 100%;
    }

    &__date {
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__icon {
        margin: 0 0 0 10px !important;

        @include for-hebrew {
            transform: scale(-1);
            margin: 0 10px 0 0 !important;
        }
    }

    &__updated-by {
        margin: 0 !important;
        font-weight: 700;
    }

    &__updated-at {
        font-size: 9px;
        text-wrap: nowrap;
    }

    &__additional {
        display: flex;
        justify-content: space-between;
        gap: 2px;
        font-size: 10px;
    }
}
</style>
